/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

export class IOSDeviceProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IOSDeviceProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIOSDeviceProto(bb: flatbuffers.ByteBuffer, obj?: IOSDeviceProto): IOSDeviceProto {
    return (obj || new IOSDeviceProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIOSDeviceProto(
    bb: flatbuffers.ByteBuffer,
    obj?: IOSDeviceProto,
  ): IOSDeviceProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IOSDeviceProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  systemName(): string | null;
  systemName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  systemName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  systemVersion(): string | null;
  systemVersion(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  systemVersion(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  model(): string | null;
  model(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  model(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  localizedModel(): string | null;
  localizedModel(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  localizedModel(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  identifierForVendor(): string | null;
  identifierForVendor(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  identifierForVendor(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  userInterfaceIdiom(): string | null;
  userInterfaceIdiom(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  userInterfaceIdiom(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startIOSDeviceProto(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addSystemName(builder: flatbuffers.Builder, systemNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, systemNameOffset, 0);
  }

  static addSystemVersion(builder: flatbuffers.Builder, systemVersionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, systemVersionOffset, 0);
  }

  static addModel(builder: flatbuffers.Builder, modelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, modelOffset, 0);
  }

  static addLocalizedModel(builder: flatbuffers.Builder, localizedModelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, localizedModelOffset, 0);
  }

  static addIdentifierForVendor(
    builder: flatbuffers.Builder,
    identifierForVendorOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(5, identifierForVendorOffset, 0);
  }

  static addUserInterfaceIdiom(
    builder: flatbuffers.Builder,
    userInterfaceIdiomOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(6, userInterfaceIdiomOffset, 0);
  }

  static endIOSDeviceProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createIOSDeviceProto(
    builder: flatbuffers.Builder,
    nameOffset: flatbuffers.Offset,
    systemNameOffset: flatbuffers.Offset,
    systemVersionOffset: flatbuffers.Offset,
    modelOffset: flatbuffers.Offset,
    localizedModelOffset: flatbuffers.Offset,
    identifierForVendorOffset: flatbuffers.Offset,
    userInterfaceIdiomOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    IOSDeviceProto.startIOSDeviceProto(builder);
    IOSDeviceProto.addName(builder, nameOffset);
    IOSDeviceProto.addSystemName(builder, systemNameOffset);
    IOSDeviceProto.addSystemVersion(builder, systemVersionOffset);
    IOSDeviceProto.addModel(builder, modelOffset);
    IOSDeviceProto.addLocalizedModel(builder, localizedModelOffset);
    IOSDeviceProto.addIdentifierForVendor(builder, identifierForVendorOffset);
    IOSDeviceProto.addUserInterfaceIdiom(builder, userInterfaceIdiomOffset);
    return IOSDeviceProto.endIOSDeviceProto(builder);
  }
}
